import { Controller } from '@hotwired/stimulus';
import { getComponent } from '@symfony/ux-live-component';
import { createElementFromHTML } from '../utilities/js/helper';

export default class extends Controller {
    async initialize () {
        this.component = await getComponent(this.element);

        const $submitBtn = this.element.querySelector('[data-form="submit"]');
        const $loadingSpinner = createElementFromHTML(window.OPTIONS.loader);

        const submitForm = () => {
            this.element.appendChild($loadingSpinner.cloneNode(true));
            this.component.action('next');
        };

        // to prevent form from submit
        this.element.querySelector('form').addEventListener('submit', (e) => {
            e.preventDefault();
        });

        if ($submitBtn) {
            $submitBtn.addEventListener('click', () => {
                submitForm();
            });
        }

        this.component.on('render:finished', (component) => {
            const $loader = this.element.querySelector('[data-loader]');
            if ($loader) {
                this.element.querySelector('[data-loader]').remove();
            }
        });
    }

    async connect () {
        this.component = await getComponent(this.element);
        this.element.addEventListener('checkout:success', this.handleFormSuccess.bind(this));

        this.element.addEventListener('checkout:success', () => {
            // cleanup shopping cart in meta navi
            this.updateCartCount();
        });
    }

    updateCartCount () {
        const $$shopBasketIndicator = document.querySelectorAll('[data-basket]');

        if ($$shopBasketIndicator.length > 0) {
            $$shopBasketIndicator.forEach($shopBasketIndicator => {
                $shopBasketIndicator.classList.remove('is--active');
                $shopBasketIndicator.textContent = 0;
            });
        }
    }

    handleFormSuccess (event) {
        const $checkoutOverview = document.querySelector('[data-checkout-overview="root"]');
        const $bookingId = $checkoutOverview.querySelector('[data-checkout-booking-id]');
        const detail = event.detail;

        if ($checkoutOverview) {
            $checkoutOverview.classList.add('checkout-overview--success');
            $checkoutOverview.scrollIntoView({ behavior: 'smooth' });
        }

        if ($bookingId) {
            $bookingId.innerHTML = detail.orderNumber;
        }
    }

    disconnect () {
        // Clean up: remove the event listener when the controller is disconnected
        this.element.removeEventListener('checkout:success', this.handleFormSuccess.bind(this));
    }
}
